import React, { useContext, useEffect, useState } from 'react'
import Sider from 'antd/es/layout/Sider'
import { Layout, Menu } from 'antd'
import { Content } from 'antd/es/layout/layout'
import { WrapperData } from '../../style/style'
import { NavLink, Route, Routes, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { columnsHunterBook, columnsHunterGroupRating, columnsHunterRating, trophyBookMenu } from './list'
import { getOptions } from './function/getOptions'
import { getRequest } from '../../request/request'
import { errors } from '../../function/errors'
import { ContextType } from '../../type/type'
import { AppContext } from '../../App'
import DynamicTrophyBook from './dynamic/DynamicTrophyBook'
const TrophyBookTheme = React.lazy(() => import('./theme/TrophyBookTheme'))
import BottomMenuInfo from '../../modules/BottomMenuInfo/BottomMenuInfo'

const TrophyBook = () => {
  const { state, isMobileWidth } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const type = pathname.split('/trophy-book/')[1]
  const [sortOrder, setSortOrder] = useState<any | null>(null)
  const [dataMenu, setDataMenu] = useState<any[]>([])
  const [collapsed, setCollapsed] = useState(false)
  const [breakpoint, setBreakpoint] = useState(false)
  const [tablePagination, setTablePagination] = useState(null)

  const handleCollapse = (collapsed: boolean, type: string) => {
    if (type === 'clickTrigger') setCollapsed(collapsed)
  }

  const handleClickMenu = () => {
    if (breakpoint) setCollapsed(true)
  }

  const optionsHunterBook = getOptions(
    '/trophy-book/hunter-book',
    '/trophy_book/national_trophy_book',
    'hunter-book',
    columnsHunterBook(t, sortOrder, tablePagination),
    'id',
    { dateFilter: true },
  )

  const optionsHunterRating = getOptions(
    '/trophy-book/hunter-rating',
    '/trophy_book/national_trophy_book/top_hunter',
    'hunter-rating',
    columnsHunterRating(t, sortOrder, tablePagination),
    'hunter_id',
  )

  const optionsHunterGroundsRating = getOptions(
    '/trophy-book/hunting-grounds-rating',
    '/trophy_book/national_trophy_book/top_hunter_farm',
    'hunting-grounds-rating',
    columnsHunterGroupRating(t, sortOrder, tablePagination),
    'hunting_farm_id',
  )

  const callback = (e: any) => {
    setSortOrder(e)
  }

  const callbackPagination = (paginataion?: any) => {
    setTablePagination(paginataion)
  }

  useEffect(() => {
    getRequest(`/pages/page/?category_id=${16}`)
      .then((res) => {
        const result = res?.data?.results

        const arr = result?.map((e: any) => ({
          key: e.id,
          label: <NavLink state={{ breadcrumbs: t('m7') }} to={`/trophy-book/${e.id}`}>{e.title}</NavLink>,
        }))

        setDataMenu([...trophyBookMenu(t), ...arr])
      })
      .catch((err) => {
        errors(err)
      })
  }, [state.lang])

  return (
    <Layout className="br-12">
      {isMobileWidth ? 
        <Menu selectedKeys={[type]} mode="inline" items={dataMenu} onClick={handleClickMenu} />
        : 
        <Sider
          width={270}
          breakpoint="lg"
          collapsedWidth="0"
          className="site-layout-background"
          collapsed={collapsed}
          onBreakpoint={(broken) => setBreakpoint(broken)}
          onCollapse={(collapsed: boolean, type: string) => handleCollapse(collapsed, type)}
          // style={{ paddingBottom: 600 }}
        >
          <Menu className="w-240" selectedKeys={[type]} mode="inline" items={dataMenu} onClick={handleClickMenu} />
          <BottomMenuInfo type="man" />
        </Sider>
      }
      <Content>
        <WrapperData>
          <Routes>
            <Route
              path="/hunter-book"
              element={
                <TrophyBookTheme
                  {...optionsHunterBook}
                  callback={callback}
                  callbackPagination={callbackPagination}
                  downloadExl={true}
                />
              }
            />
            <Route
              path="/hunter-rating"
              element={
                <TrophyBookTheme
                  {...optionsHunterRating}
                  callback={callback}
                  callbackPagination={callbackPagination}
                  medal={true}
                />
              }
            />
            <Route
              path="/hunting-grounds-rating"
              element={
                <TrophyBookTheme
                  {...optionsHunterGroundsRating}
                  callback={callback}
                  callbackPagination={callbackPagination}
                  medal={true}
                />
              }
            />
            <Route
              path="/information"
              element={
                <BottomMenuInfo type="man" />
              }
            />
            <Route path="/:id" element={<DynamicTrophyBook />} />
          </Routes>
        </WrapperData>
      </Content>
    </Layout>
  )
}

export default TrophyBook
